module.exports = __webpack_public_path__ + "static/media/google-tag-manager-server-side-data.73001017.md";